const options = (method, Authorization, bodyData) => {
  const headers = { "Content-Type": "application/json" };
  headers.Authorization = Authorization;
  headers.Application = global.APP_HEADER ?? "";
  let requestOptions;
  if (method === "POST") {
    requestOptions = {
      method: method,
      headers,
      body: JSON.stringify(bodyData),
    };
  } else {
    requestOptions = {
      method: method,
      headers,
    };
  }
  return requestOptions;
};

const optionsLogExt = (method, Authorization, bodyData) => {
  const headers = {
    "Content-Type": "application/json",
    Authorization,
    Application: global.APP_HEADER ?? "",
    IdOrganizacion: "365509c8-9596-4506-a5b3-487782d5876e", // Se agrega el nuevo header
  };

  let requestOptions;
  if (method === "POST") {
    requestOptions = {
      method: method,
      headers,
      body: JSON.stringify(bodyData),
    };
  } else {
    requestOptions = {
      method: method,
      headers,
    };
  }
  return requestOptions;
};

const optionsConfig = (method, Authorization, bodyData) => {
  const headers = { "Content-Type": "application/json" };
  headers.Authorization = Authorization;
  headers.Application = global.APP_HEADERCONF ?? "";
  headers["idorganizacion"] = global.APP_IDORG ?? "";
  headers["Accept-Language"] = "es";
  let requestOptions;
  if (method === "POST") {
    requestOptions = {
      method: method,
      headers,
      body: JSON.stringify(bodyData),
    };
  } else {
    requestOptions = {
      method: method,
      headers,
    };
  }
  return requestOptions;
};

const optionsModuleMenu = (method, Authorization, bodyData) => {
  const headers = { "Content-Type": "application/json" };
  headers.Authorization = Authorization;
  headers.Application = global.APP_HEADERCONF ?? "";
  headers["idorganizacion"] = global.APP_IDORG ?? "";
  headers["Accept-Language"] = "es";
  let requestOptions;
  if (method === "POST") {
    requestOptions = {
      method: method,
      headers,
      body: JSON.stringify(bodyData),
    };
  } else {
    requestOptions = {
      method: method,
      headers,
    };
  }
  return requestOptions;
};

const requestOptionsServices = {
  options,
  optionsLogExt,
  optionsConfig,
  optionsModuleMenu,
};

export default requestOptionsServices;
